import {createSlice} from "@reduxjs/toolkit";

const initialDriverDocsState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  driverdocForEdit: undefined,
  lastError: null
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const driverdocsSlice = createSlice({
  name: "driverdocs",
  initialState: initialDriverDocsState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getDriverDocById
    driverdocFetched: (state, action) => {
      state.actionsLoading = false;
      state.driverdocForEdit = action.payload.driverdocForEdit;
      state.error = null;
    },
    // findDriverDocs
    driverdocsFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    // createDriverDoc
    driverdocCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.push(action.payload.driverdoc);
    },
    // updateDriverDoc
    driverdocUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.map(entity => {
        if (entity.id === action.payload.driverdoc.id) {
          return action.payload.driverdoc;
        }
        return entity;
      });
    },
    // deleteDriverDoc
    driverdocDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(el => el.id !== action.payload.id);
    },
    // deleteDriverDocs
    driverdocsDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        el => !action.payload.ids.includes(el.id)
      );
    },
    // driverdocsUpdateState
    driverdocsStatusUpdated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      const { ids, status } = action.payload;
      state.entities = state.entities.map(entity => {
        if (ids.findIndex(id => id === entity.id) > -1) {
          entity.status = status;
        }
        return entity;
      });
    }
  }
});
